import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-bg-gray-200 q-my-md q-pa-md tw-rounded-md" }
const _hoisted_2 = { class: "text-h4 q-my-sm" }
const _hoisted_3 = {
  key: 0,
  class: "text-h4"
}

import RecapField from './RecapField.vue'
import InventoryItemSelection from '../task_profile/InventoryItemSelection.vue'
import { ref, computed, inject, onMounted, watchEffect } from 'vue'
import { Form, LocaleStrings, Product } from '../../types/recap'
import { useDisplayLogic } from '../../composables/recaps/useDisplayLogic'
import { useLogic } from '../../composables/recaps/useLogic'
import { useRecapHelpers } from '../../composables/recaps/useRecapHelpers'
import { useI18n } from 'vue-i18n'
import { useSharedRecap } from '../../composables/recaps/useRecap'


export default /*#__PURE__*/_defineComponent({
  __name: 'RecapForm',
  props: {
    form: {},
    product: {},
    repeatingIndex: {},
    lastSurvey: { type: Boolean }
  },
  emits: ['addSurvey', 'removeSurvey'],
  setup(__props: any, { expose: __expose }) {

const {
  getFieldRef,
  recapLanguage,
  recapId,
  taskOrStoreId,
  recapType,
  mapData,
  getAreAllFieldsForFormHidden,
} = useSharedRecap()

const props = __props



const { t } = useI18n()

// Fields
const fields = computed(() => props.form.items || props.form.fields || [])

// Helpers
const { isFieldBlock } = useRecapHelpers()

// Languages
const formName = computed(
  () => props.form.name_l10n[recapLanguage.value as keyof LocaleStrings] || props.form.name
)

// Display Logic
const { shouldBeHidden, handleAllDisplayLogic } = useDisplayLogic(
  recapId.value,
  taskOrStoreId,
  recapType
)
const isFormHidden = ref(false)
const logicHidesForm = ref(false)
watchEffect(() => {
  if (shouldBeHidden.value || logicHidesForm.value || getAreAllFieldsForFormHidden(props.form.id)) {
    isFormHidden.value = true
  } else {
    isFormHidden.value = false
  }
})

// inventory Item Selection
const inventoryItemSelection = inject<any>('inventoryItemSelection', false)

function getFormIsHidden() {
  return isFormHidden.value
}
function getFormId() {
  return props.form.id
}
function getFormType() {
  return props.form.form_type
}
function getProductsId() {
  return props.product?.id
}
function getLogicGroups() {
  return props.form.logic_groups
}
function getRepeatingIndex() {
  return props.repeatingIndex
}
function runLogic(selfRef: any, dependenceRefs: any[]) {
  const { checkLogicConditions } = useLogic(selfRef, dependenceRefs)
  const logicResult = checkLogicConditions(props.repeatingIndex)
  // Invert the result; the variable is for if the form *is* hidden by logic
  logicHidesForm.value = !logicResult
}
__expose({
  getFormIsHidden,
  getFormId,
  getFormType,
  getProductsId,
  getLogicGroups,
  getRepeatingIndex,
  runLogic,
})

onMounted(() => {
  // Run Display Logic
  handleAllDisplayLogic(props.form)
})

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(formName.value.replaceAll('_', ' ')), 1),
    (props.product)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(t)('recap.product', 0, { locale: _unref(recapLanguage) })) + ": " + _toDisplayString(_ctx.product?.name), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields.value, (fieldOrFieldBlock) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: `${_unref(recapType)}-${_unref(taskOrStoreId)}-${fieldOrFieldBlock.id}-${_ctx.repeatingIndex}-${_unref(isFieldBlock)(
        fieldOrFieldBlock
      )}`
      }, [
        (!_unref(isFieldBlock)(fieldOrFieldBlock))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(RecapField, {
                field: fieldOrFieldBlock,
                "repeating-index": _ctx.repeatingIndex,
                ref_for: true,
                ref: (_unref(getFieldRef) as any),
                onValueChange: ($event: any) => (_unref(mapData)(fieldOrFieldBlock.id, _ctx.repeatingIndex))
              }, null, 8, ["field", "repeating-index", "onValueChange"]),
              (props.form.form_type === 'survey')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (props.lastSurvey)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          push: "",
                          color: "negative",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('removeSurvey')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Remove Response ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_btn, {
                      push: "",
                      color: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('addSurvey'))),
                      class: "tw-ml-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add Response ")
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (_unref(inventoryItemSelection))
      ? (_openBlock(), _createBlock(InventoryItemSelection, {
          key: 1,
          task: _unref(inventoryItemSelection).task,
          "task-properties": _unref(inventoryItemSelection).taskProperties,
          "inventory-item-selection": _unref(inventoryItemSelection).inventoryItemSelection,
          "onUpdate:inventoryItemSelection": _unref(inventoryItemSelection).updateInventoryItem
        }, null, 8, ["task", "task-properties", "inventory-item-selection", "onUpdate:inventoryItemSelection"]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, !isFormHidden.value]
  ])
}
}

})